import React, { useEffect, useRef, useState } from 'react'
import { getNavigationOptions } from '../../../../../utils/drawerNavigation/drawerNavigationHelpers';
import { DrawerNavigation } from '../../DrawerNavigation/DrawerNavigation';

export const useDrawerNavigation = (options) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [showSubmenu, setShowSubmenu] = useState(false);
    const submenuOptRef = useRef(-1)
    const { settings, isChannel, drawerNavigation, paramsQuery, isDrawerOpen, currentTags = [], query, selectChannelHandler,t, additionalOptions = [] ,profileData} = options;
    const { mode, selectedId, submenu } = drawerNavigation;
    const { submenu: { listOptions, option: submenuOption } } = drawerNavigation

    useEffect(() => {
        setShowSubmenu(!!(anchorEl && submenuOptRef.current === submenuOption))
    }, [listOptions, submenuOption, anchorEl])

    const handleOptionClick = (option) => {
        submenuOptRef.current = option.id
        option.onClick()
    }

    const handleClick = (event, option) => {
        handleOptionClick(option)
        setAnchorEl(event.currentTarget);
        event.stopPropagation()
    };

    const handleClose = () => {
        submenuOptRef.current = -1
        setAnchorEl(null);
    };



    const navOptions = isChannel ? additionalOptions : getNavigationOptions(mode, t, additionalOptions, settings)

    const Navigation = <DrawerNavigation
        submenu={submenu}
        query={query}
        isDrawerOpen={isDrawerOpen}
        paramsQuery={paramsQuery}
        selectedOptionId={selectedId}
        isChannel={isChannel}
        options={navOptions}
        anchorEl={anchorEl}
        currentTags={currentTags}
        showSubmenu={showSubmenu}
        profileData={profileData}
        handleClick={handleClick}
        handleClose={handleClose}
        handleOptionClick={handleOptionClick}
        selectChannelHandler={selectChannelHandler}
    />
    return [Navigation]
}